var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 104,
    viewBox: "0 0 116 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6536 7.64375C55.5706 4.27244 60.4294 4.27244 62.3465 7.64376L111.751 94.5285C113.647 97.8617 111.239 102 107.405 102H8.59495C4.76053 102 2.35314 97.8617 4.24851 94.5285L53.6536 7.64375Z",
    stroke: "#20A2E9",
    strokeWidth: 3.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 43.5,
    width: 48,
    height: 47,
    rx: 23.5,
    stroke: "#39DF9E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8618 69.6587H55.1685L54.3965 54.8701H59.6338L58.8618 69.6587ZM54.3359 74.8354C54.3359 73.9878 54.563 73.347 55.0171 72.9131C55.4712 72.4792 56.1322 72.2622 57 72.2622C57.8376 72.2622 58.4834 72.4842 58.9375 72.9282C59.4017 73.3722 59.6338 74.008 59.6338 74.8354C59.6338 75.6326 59.4017 76.2633 58.9375 76.7275C58.4733 77.1816 57.8275 77.4087 57 77.4087C56.1523 77.4087 55.4964 77.1867 55.0322 76.7427C54.568 76.2886 54.3359 75.6528 54.3359 74.8354Z",
    fill: "#20A2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.ce6fde1f.svg";
export { ForwardRef as ReactComponent };